export const VideoQualities = {
  hls: { label: 'Automática', value: 'hls' },
  high: { label: '1080p60', value: 'high' },
  medium2: { label: '1080p30', value: 'hls_1080p30' },
  medium: { label: '720p', value: 'medium' },
  low: { label: '480p', value: 'low' },
};
